/** Shared sx tokens for TaskForm field layout (modal path). */

export const formGroupSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const fieldLabelSx = {
  display: 'block',
  fontWeight: 700,
  color: 'text.secondary',
  fontSize: '0.875rem',
};

export const nativeInputSx = {
  width: '100%',
  height: 40,
  boxSizing: 'border-box',
  borderRadius: 1,
  fontSize: '1rem',
  color: 'grey.800',
  border: 1,
  borderColor: 'grey.300',
  bgcolor: 'background.paper',
  px: 1,
  '&:focus:not(:focus-visible)': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: '2px',
    borderColor: 'secondary.main',
  },
  '&:disabled': {
    bgcolor: 'grey.100',
    color: 'grey.500',
    borderColor: 'grey.200',
    cursor: 'not-allowed',
  },
};

export const planningSectionSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  bgcolor: 'grey.100',
  p: 2,
  borderRadius: 1,
  my: 1,
};

export const recurrenceOptionsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  flexWrap: 'wrap',
  py: 1,
  borderTop: 1,
  borderColor: 'grey.200',
};

export const formGroupInlineSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  '& label': {
    whiteSpace: 'nowrap',
    fontWeight: 400,
    fontSize: '0.875rem',
    color: 'text.secondary',
  },
  '& input, & select': {
    width: 'auto',
    height: 32,
    px: 0.5,
    borderRadius: 1,
    border: 1,
    borderColor: 'grey.300',
    bgcolor: 'background.paper',
    fontSize: '0.875rem',
  },
};

export const taskBreadcrumbSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: 'text.secondary',
  fontSize: '0.875rem',
};

export const autocompleteTextFieldSx = {
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'secondary.main',
  },
};
